import { Routes, Route, Navigate } from "react-router-dom";
import Header from './components/general/Header';
import Footer from './components/general/Footer';
import Services from "./components/pages/Services";
import Contact from "./components/pages/Contact";
import Home from "./components/pages/Home";
import About from "./components/pages/About";
import PageNotFound from "./components/general/Pagenotfound";
import AdminLogin from "./Adminpanel/AdminLogin";
import AdminDashboard from "./Adminpanel/AdminDashboard";
import ManageService from "./Adminpanel/InventoryService/ManageService";
import AdminSidebar from "./Adminpanel/AdminSidebar";
import { useState } from "react";
import PincodeMaster from "./Adminpanel/GeneralComponent/PincodeMaster";
import Banner from "./Adminpanel/GeneralComponent/Banner";
import Setting from "./Adminpanel/GeneralComponent/Setting";
import ManageUser from "./Adminpanel/Users/ManageUser";
import SubscriptionPlan from "./Adminpanel/Plan/SubscriptionPlan";
import ManageStaff from "./Adminpanel/staff/ManageStaff";
import DailyAttendence from "./Adminpanel/staff/DailyAttendence";
import ManageTask from "./Adminpanel/staff/ManageTask";
import ManageOrder from "./Adminpanel/InventoryService/ManageOrder";
import OrderDetail from "./Adminpanel/InventoryService/OrderDetail";
import Payroll from "./Adminpanel/staff/Payroll";
import MonthlyAttendence from "./Adminpanel/staff/MonthlyAttendence";
import SuscriptionHistory from "./Adminpanel/Plan/SuscriptionHistory";
import TaskList from "./Adminpanel/Task/TaskList";
import SubscriptionReport from "./Adminpanel/Plan/SubscriptionReport";
import CustomPlan from "./Adminpanel/Plan/CustomPlan";
import TaskReport from "./Adminpanel/Task/TaskReport";
import QuickHistory from "./Adminpanel/QuickService/QuickHistory";
import QuickPednigHistory from "./Adminpanel/QuickService/QuickPednigHistory";
import Withdrawal from "./Adminpanel/staff/Withdrawal";
import SettlementReport from "./Adminpanel/QuickService/SettlementReport";
import SaleReport from "./Adminpanel/QuickService/SaleReport";
import SiteEnquiry from "./Adminpanel/GeneralComponent/SiteEnquiry";
import DeleteAccount from "./components/pages/DeleteAccount";
import HireStaff from "./components/pages/HireStaff";
import PrivacyPolicy from "./components/pages/PrivacyPolicy";
import TermCondition from "./components/pages/TermCondition";
import TimeSlot from "./Adminpanel/GeneralComponent/TimeSlot";
import ScheduleService from "./Adminpanel/QuickService/ScheduleService";
import './css/Adminpanel/Pages.css';
import "react-toastify/dist/ReactToastify.css";
function App() {
  // const isAdmin = localStorage.getItem("isAdmin");
  const [isAdmin, setIsAdmin] = useState(localStorage.getItem("isAdmin") === "true");
  const storedUserData = localStorage.getItem("userData");
  const userData = storedUserData ? JSON.parse(storedUserData) : null;

  // console.log(userData);

  const collapsed = false;
  return <>
      {/* Show Header/Footer only for public site */}
    

      {!isAdmin && <>
          <Header />
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
             <Route path="/delete-account" element={<DeleteAccount />} />
              <Route path="/hire-staff" element={<HireStaff />} />
             <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/term-and-condition" element={<TermCondition />} />

            <Route path="/admin-login" element={<AdminLogin setIsAdmin={setIsAdmin} />} />
            {/* Catch all */}
            <Route path="/*" element={<PageNotFound />} />
          </Routes>
          <Footer />

        </>}

      {isAdmin && <>
          <AdminSidebar />

          <div className={`dashboard-sidebar-right ${collapsed ? "collapsed" : ""}`}>
            <Routes>
                <Route path="/" element={<Navigate to="/admin/admin-dashboard" replace />} />
              <Route exact path="/admin/admin-dashboard" element={<AdminDashboard />} />
              <Route exact path="/admin/pincode-master" element={<PincodeMaster />} />
               <Route exact path="/admin/banner" element={<Banner />} />
               <Route exact path="/admin/setting" element={<Setting userData={userData} />} />
                <Route exact path="/admin/site-enquiry" element={<SiteEnquiry />} />
                   <Route exact path="/admin/time-slot" element={<TimeSlot />} />

              {/* Service */}
              <Route path="/admin/manage-service" element={<ManageService />} />
               <Route path="/admin/manage-order" element={<ManageOrder />} />
                <Route path="/admin/order-detail" element={<OrderDetail />} />


              {/* manage user */}
            <Route exact path="/admin/user-list" element={<ManageUser />} />

            {/* Subscription plan */} 
            <Route exact path="/admin/subscription-plan" element={<SubscriptionPlan />} />
             <Route exact path="/admin/subscription-history" element={<SuscriptionHistory />} />
            <Route exact path="/admin/subscription-report" element={<SubscriptionReport />} />
             <Route exact path="/admin/custom-plan" element={<CustomPlan />} />


            {/* Manage Staff */}
             <Route exact path="/admin/staff" element={<ManageStaff />} />
             <Route exact path="/admin/daily-attendence" element={<DailyAttendence />} />
                <Route exact path="/admin/manage-task" element={<ManageTask />} />
               <Route exact path="/admin/payroll" element={<Payroll />} />
            <Route exact path="/admin/monthly-attendence" element={<MonthlyAttendence />} />
              <Route exact path="/admin/staff-withdrawal" element={<Withdrawal userData={userData} />} />
            

            {/* Task */}
                 <Route exact path="/admin/task" element={<TaskList />} />
                 <Route exact path="/admin/task-report" element={<TaskReport />} />


                 {/*Qu9ick Service*/}
                  <Route exact path='/admin/quick-history' element={<QuickHistory />} />
                   <Route exact path="/admin/quick-pending" element={<QuickPednigHistory />} />
                    <Route exact path="/admin/settlement-report" element={<SettlementReport />} />
                        <Route exact path="/admin/sale-report" element={<SaleReport />} />
                     <Route exact path="/admin/schedule-service" element={<ScheduleService />} />

            </Routes>
          </div>
        </>}

    </>;
}
export default App;
